import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { HeaderContainer, LogOutButton } from "./styled";

import * as actions from "../../store/modules/auth/actions";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";
import { toast } from "react-toastify";

export const Header = () => {
  const [admin, setAdmin] = useState(false);
  const [email, setEmail] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogOutClick = async () => {
    try {
      await api.post("/user/logout");
      api.defaults.headers.Authorization = null;
      dispatch(actions.loginFailure());
      navigate("/");
    } catch (err) {
      toast.error("Ocorreu um erro: ", err);
    }
  };

  const isAdmin = async () => {
    try {
      const res = await api.get("/user/me");
      setAdmin(res.data.role === "admin");
      setEmail(res.data.email);
      setIsLoggedIn(true);
    } catch (err) {
      setIsLoggedIn(false);
    }
  };

  useEffect(() => {
    isAdmin();
  });

  return (
    <HeaderContainer>
      <a href="https://ticoopbrasil.coop.br/oportunidades-ti/">
        <img
          src="https://ticoopbrasil.coop.br/wp-content/uploads/2020/12/logo-ticoop-cor.png.webp"
          alt="Logo Ticoop"
          class="logo logo-big"
        />
        <img
          src="https://ticoopbrasil.coop.br/wp-content/uploads/2021/01/cropped-icon.png"
          alt="Logo Ticoop"
          class="logo logo-small"
        />
      </a>
      {admin ? (
        <LogOutButton onClick={() => navigate("/admin")}>Admin</LogOutButton>
      ) : isLoggedIn ? (
        <LogOutButton onClick={() => navigate("/")}>Perfil</LogOutButton>
      ) : (
        <></>
      )}
      {isLoggedIn ? (
        <LogOutButton onClick={handleLogOutClick}>
          <span>Sair</span>
          <span style={{ fontSize: ".6rem" }}>{`Logado como (${email})`}</span>
        </LogOutButton>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <a href="https://ticoopbrasil.coop.br/oportunidades-ti/">
            <LogOutButton>Oportunidades</LogOutButton>
          </a>
        </div>
      )}
    </HeaderContainer>
  );
};
